import { defineMessages } from 'react-intl';
import { isDefined, isBlank } from 'helpers/verify';

const messages = defineMessages({
  required: {
    id: 'validators.required',
    defaultMessage: 'This field is required.',
  },
});

export const requiredValidator = val => {
  if (isBlank(val)) {
    return messages.required;
  }
};

export const requiredIfExistsValidator = val => {
  if (isDefined(val) && isBlank(val)) {
    return messages.required;
  }
};
